import React, { Component } from 'react';
import { Link } from 'react-router';
import LeftMainmenuItem from '../../../helpers/LeftMainmenuItem';
import AppMenuConfig from '../../../../config/Menu';
import { buildInitialValues } from './utils/themeUtils';
import { ColorPanel } from './panels/ColorPanel';
import { TypographyPanel } from './panels/TypographyPanel';
import { PlaceholderPanel } from './panels/PlaceholderPanel';
import { ShadowComponent } from '../components/ShadowComponent';
import { connect } from 'react-redux';
import { FontFamilyProperty } from '../../../../../lib/css-property-parser/FontFamilyProperty';
import { actions } from '../../../../store/InContextThemeStore';
import { RangePanel } from './panels/RangePanel';

class InContextSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fontFamilies: new FontFamilyProperty(props.font),
            open: { 'root/colors': true },
            values: buildInitialValues(
                AppMenuConfig.inContextTheme, 
                props.inContextTheme || {}
            ),
            selectedKey: 'colors',
        };
        this.toggle = this.toggle.bind(this);
        this.select = this.select.bind(this);
        this.updateValue = this.updateValue.bind(this);
        this.keyFor = this.keyFor.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.font !== nextProps.font) {
            const nextFontFamilies = new FontFamilyProperty(nextProps.font);
            this.setState({
                fontFamilies: nextFontFamilies,
            });
        }
        
        // Update values when inContextTheme store changes
        if (this.props.inContextTheme !== nextProps.inContextTheme) {
            const updatedValues = buildInitialValues(
                AppMenuConfig.inContextTheme,
                nextProps.inContextTheme || {}
            );
            this.setState({
                values: updatedValues
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.values !== this.state.values) {
            const keysToUpdate = Object.keys(this.state.values).filter(
                key => (key === 'spacing' || key === 'radius' || key.startsWith('shadow-')) && key !== 'shadow-color'
            );

            if (keysToUpdate.length) {
                keysToUpdate.forEach(key => {
                    this.updateSliderBackground(this.state.values[key], key);
                });
            }
        }
    }
    toggle(key) {
        var next = Object.assign({}, this.state.open);
        next[key] = !next[key];
        this.setState({ open: next });
    }

    select(key) {
        this.setState({ selectedKey: key });
        if (this.props.onSelect) this.props.onSelect(key);
    }

    keyFor(prefix, node) {
        return (prefix || 'root') + '/' + (node.key || node.name);
    }

    updateValue(rowKey, value) {
        var next = Object.assign({}, this.state.values, { [rowKey]: value });
        this.setState({ values: next });

        this.props.updateLightTheme(rowKey, value);
        
        if ((rowKey === 'spacing' || rowKey === 'radius' || rowKey.startsWith('shadow-')) && rowKey !== 'shadow-color') {
            this.updateSliderBackground(value, rowKey);
        }

        if (this.props.onChange) this.props.onChange(rowKey, value);
    }

    updateSliderBackground(targetValue, key) {
        const sliderElement = document.querySelector(`#in-context-slider-${key}`);
        if (!sliderElement) return;
        const value = parseFloat(targetValue) || 0;
        const min = parseFloat(sliderElement.min) || 0;
        const max = parseFloat(sliderElement.max) || 100;

        const percentage = ((value - min) / (max - min)) * 100;
        document.querySelector(`#in-context-slider-${key}`).style.setProperty('--slider-progress', `${percentage}%`);
    }

    renderItem(item, prefix) {
        if (item.key === 'colors') {
            return (
                <ColorPanel
                    key={item.key}
                    item={item}
                    prefix={prefix}
                    open={this.state.open}
                    values={this.state.values}
                    toggle={this.toggle}
                    updateValue={this.updateValue}
                    keyFor={this.keyFor}
                />
            );
        }

        if (item.key === 'typography') {
            return (
                <TypographyPanel
                    key={item.key}
                    item={item}
                    prefix={prefix}
                    open={this.state.open}
                    values={this.state.values}
                    toggle={this.toggle}
                    updateValue={this.updateValue}
                    keyFor={this.keyFor}
                />
            );
        }
        if (item.key === 'radius') {
            return (
                <RangePanel
                    key={item.key}
                    item={item}
                    prefix={prefix}
                    open={this.state.open}
                    values={this.state.values}
                    updateValue={this.updateValue}
                    toggle={this.toggle}
                    keyFor={this.keyFor}
                    updateSliderBackground={this.updateSliderBackground}
                    min="0"
                    max="5"
                    step={0.025}
                />
            )
        }
        if (item.key === 'spacing') {
            return (
                <RangePanel
                    key={item.key}
                    item={item}
                    prefix={prefix}
                    open={this.state.open}
                    values={this.state.values}
                    updateValue={this.updateValue}
                    toggle={this.toggle}
                    keyFor={this.keyFor}
                    updateSliderBackground={this.updateSliderBackground}
                    min="0"
                    max="0.35"
                    step={0.01}
                />
            )
        }
        if (item.key === 'shadow') {
            return (
                <ShadowComponent
                    key={item.key}
                    item={item}
                    prefix={prefix}
                    open={this.state.open}
                    values={this.state.values}
                    updateValue={this.updateValue}
                    toggle={this.toggle}
                    keyFor={this.keyFor}
                />
            );
        }

        return (
            <PlaceholderPanel
                key={item.key}
                item={item}
                prefix={prefix}
                open={this.state.open}
                selectedKey={this.state.selectedKey}
                toggle={this.toggle}
                keyFor={this.keyFor}
            />
        );
    }

    render() {
        return (
            <aside className="in-context-sidebar">
                <div className="container">
                    <Link to="/">
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className="spark-icon-arrow-basic-left spark-icon--xd" />
                            </div>
                            <div className="col-md-10 link-to-home">Home</div>
                        </div>
                    </Link>
                </div>
                <LeftMainmenuItem icon="spark-icon-design-palette" title="Theme" copy="" />
                <ul className="in-context-menu">
                    {AppMenuConfig.inContextTheme.map((item) => this.renderItem(item, 'root'))}
                </ul>
            </aside>
        );
    }
}
const mapStateToProps = state => {
    return {
        ...state.theme,
        inContextTheme: state.app.data.inContextTheme.light || {}
    };
};

const mapDispatchToProps = dispatch => ({
    updateLightTheme: (key, value) => dispatch(actions.updateLightTheme(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InContextSidebar);


// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/InContextSidebar.js